import { Button } from '@material-ui/core';
import React from 'react';
import styles from './TemplateBubbles.module.css';
import { Grow } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TemplateBubbles = ({ setIsTemplate, isOverlayed = false, templates = [] }) => {
  const { t } = useTranslation();
  return (
    <Grow in={true}>
      <div className={isOverlayed ? styles.rightOverlay : styles.right}>
        <div className={styles.rightUpper}>
          <h3 className={styles.h3}>{t('templates.title')}</h3>
          <div className={styles.title}>{t('templates.currentTemplates')}</div>
          <div className={styles.templateContainer}>
            {isOverlayed ? (
              <>
                <div className={styles.templateBubble}>{`${t('templates.sample')} 1`}</div>
                <div className={styles.templateBubble}>{`${t('templates.sample')} 2`}</div>
                <div className={styles.templateBubble}>{`${t('templates.sample')} 3`}</div>
              </>
            ) : templates.length > 0 ? (
              templates.map((el, idx) => {
                return (
                  <div className={styles.templateBubble} key={idx}>
                    {el.name}
                  </div>
                );
              })
            ) : (
              <div>{t('templates.noTemplates')}</div>
            )}
          </div>
        </div>
        <Button
          disabled={isOverlayed}
          className={styles.buttonDark}
          onClick={() => {
            setIsTemplate(true);
          }}>
          {t('templates.editTemplates')}
        </Button>
      </div>
    </Grow>
  );
};

export default TemplateBubbles;
